import router from "@/router/index";
import {createDialog} from "@/components/Message"
import i18n from "@/i18n";
import store from '@/store/index'
export const goPath = (path) => {
    if(!path) return createDialog.warn(i18n.global.t('confirm.notYetOpn'))
    store.commit('setActiveShow',false)
    router.push(path)
}